import { toQueryString } from "./toQueryString";

type Params = Record<string, any>;

interface IndexParams {
  params?: Params;
  spaceSlug?: string;
}

interface NewParams {
  spaceSlug: string;
}

interface DuplicateParams {
  params?: Params;
  slug?: string;
  spaceSlug?: string;
}

interface PinParams {
  params?: Params;
  slug?: string;
  spaceSlug?: string;
}

interface PostsPathParam {
  hash?: string;
  params?: Params;
  slug?: string;
  spaceSlug?: string;
}

export const postsPath = ({
  spaceSlug,
  slug,
  params = {},
  hash = "",
}: PostsPathParam = {}) =>
  Object.keys(params).length
    ? `/c/${spaceSlug}/${slug}?${toQueryString(params)}${hash}`
    : `/c/${spaceSlug}/${slug}${hash}`;

export const posts = {
  index: ({ spaceSlug, params }: IndexParams = {}) =>
    `/c/${spaceSlug}${
      params && Object.keys(params).length ? "?" : ""
    }${toQueryString(params)}`,
  new: ({ spaceSlug }: NewParams) => `/c/${spaceSlug}/new`,
  show: postsPath,
  destroy: postsPath,
  newDuplicate: ({ spaceSlug, slug, params }: DuplicateParams = {}) =>
    `/c/${spaceSlug}/${slug}/new_duplicate?${toQueryString(params)}`,
  pinToTop: ({ spaceSlug, slug, params }: PinParams = {}) =>
    `/c/${spaceSlug}/${slug}/pin?${toQueryString(params)}`,
};
